<div class="container-fluid well">
    <h5>{{title}}</h5>

    <div class="row">
        <div class="col-xs-3">
            <label
                class="control-label"
                for="lodgementType">
                Lodge type
            </label>
            <div class="input-group">
                <input
                    type="text"
                    id="lodgementType"
                    name="lodgementType"
                    class="form-control"
                    placeholder="Lodgement Type is Undefined"
                    autocomplete="off"
                    readonly="readonly"
                    title="Lodgement type"
                    [(ngModel)]="getModel().lodgementType.value" />
            </div>
        </div>

        <div
            [hidden]="!hasLodgePermissions()"
            class="col-xs-3">
            <label
                class="control-label required-input"
                for="customer">
                Customer number
            </label>
            <div>
                <ng-select
                    class="nlr-ng-select"
                    [ngClass]="{'has-error': customer | formFieldHasError}"
                    [searchable]="false"
                    [clearable]="false"
                    id="customer"
                    name="customer"
                    title="Select a customer number for billing purposes"
                    placeholder="Select"
                    [items]="customers"
                    [trackByFn]="customerTrackBy"
                    bindLabel="financialAccountNumber"
                    [disabled]="isCustomerDisabled()"
                    [(ngModel)]="getModel().customer"
                    required
                    #customer="ngModel">
                </ng-select>
            </div>
        </div>

        @if (hasInformationPermissions()) {
            <div class="col-xs-3">
                <div class="row">
                    <div class="col-xs-7">
                        <label class="control-label">Total plan lots</label>
                        <div class="input-group">
                            <input
                                id="planLots"
                                name="planLots"
                                type="number"
                                class="form-control"
                                readonly="readonly"
                                title="The total number of lots created on the plan"
                                [disabled]="isPlanLotsDisabled()"
                                [(ngModel)]="getModel().planLots" />
                        </div>
                    </div>
                    @if (getPlanLotsError()) {
                        <div class="col-xs-5">
                            <label class="control-label">&nbsp;</label>
                            <div class="input-group">
                                <span class="plan-lots-error">
                                    <i
                                        class="nlrp-icon nlrp-icon-error error"
                                        [title]="getPlanLotsError()">
                                    </i>
                                </span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>

    @if (hasLodgePermissions()) {
        <div class="row">
            <div class="col-xs-6">
                <label
                    class="control-label required-input"
                    for="lodgementEmailAddress">
                    Lodgement receipt email address
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-error': lodgementEmailAddress | formFieldHasError}">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        type="email"
                        id="lodgementEmailAddress"
                        name="lodgementEmailAddress"
                        class="form-control"
                        placeholder="Enter email address"
                        title="Enter email address for lodgement receipt"
                        maxlength="100"
                        required
                        autocomplete="off"
                        nlrEmail
                        [disabled]="isLodgementEmailAddressDisabled()"
                        [(ngModel)]="getModel().lodgementEmailAddress"
                        #lodgementEmailAddress="ngModel" />
                </div>
                @if (lodgementEmailAddress | formFieldHasError) {
                    <div class="help-block">
                        <span>Error!</span>
                        <span>Lodgement receipt email address is not valid.</span>
                    </div>
                }
            </div>
        </div>
    }

    @if (hasLodgePermissions() && getModel().planPurpose?.lotSync) {
        <div class="row">
            <div class="col-xs-12">
                <div class="form-inline">
                    <div class="form-group vertical-group">
                        @if (getModel().lotSync) {
                            <label
                                class="control-label"
                                for="lotSync">
                                &nbsp;
                            </label>
                        }
                        <div class="checkbox mgt20">
                            <div
                                class="checkbox-inline"
                                title="If an Application for new titles document has been lodged, selecting this option for a CAD Plan will assign a High Priority to Plan Examination. Portal Plans are already assigned a High Priority.">
                                <i
                                    class="nlrp-icon"
                                    [ngClass]="{'active': getModel().lotSync, 'nlrp-icon-check-box-selected': this.getModel().lotSync, 'nlrp-icon-check-box-unselected': !this.getModel().lotSync}"
                                    (click)="lotSyncHandler()">
                                </i>
                                <span>Readiness to proceed</span>
                                <input
                                    type="checkbox"
                                    name="lotSync"
                                    id="lotSync"
                                    tabindex="-1"
                                    [disabled]="isLotSyncDisabled()"
                                    [(ngModel)]="getModel().lotSync"
                                    (change)="onChangeLotSync()"
                                    style="visibility: hidden;"
                                    #lotSync="ngModel" />
                            </div>
                        </div>
                    </div>
                    @if (getModel().lotSync) {
                        <div class="form-group">
                            <label
                                class="control-label required-input"
                                for="applicationForTitlesDocumentIdentifier">
                                Application document
                            </label>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': applicationForTitlesDocumentIdentifier | formFieldHasError}">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="text"
                                    id="applicationForTitlesDocumentIdentifier"
                                    name="applicationForTitlesDocumentIdentifier"
                                    class="form-control"
                                    title="The application for new titles document number."
                                    maxlength="12"
                                    size="12"
                                    autocomplete="off"
                                    required
                                    [disabled]="isApplicationForTitlesDocumentIdentifierDisabled()"
                                    [(ngModel)]="getModel().applicationForTitlesDocumentIdentifier"
                                    #applicationForTitlesDocumentIdentifier="ngModel"
                                    #applicationForTitlesDocumentIdentifierInput
                                    [nlrPattern]="documentPattern"
                                    nlrUppercase />
                            </div>
                            @if (applicationForTitlesDocumentIdentifier.errors?.nlrPattern) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Incorrect entry, format should be document prefix and number e.g. M123456, T8606/1961</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
